import React, { useEffect } from 'react';
import { useSocket } from '../context/SocketContext';

const ConnectionStatus = () => {
  const { isConnected, onlineUsers, socket } = useSocket();

  useEffect(() => {
    console.log('🔌 ConnectionStatus - isConnected:', isConnected);
    console.log('🔌 ConnectionStatus - socket:', socket);
    console.log('🔌 ConnectionStatus - socket.connected:', socket?.connected);
    console.log('🔌 ConnectionStatus - onlineUsers count:', onlineUsers.size);
  }, [isConnected, socket, onlineUsers]);

  return (
    <div className="fixed bottom-4 left-4 z-50">
      <div className={`flex items-center space-x-2 px-3 py-2 rounded-full text-xs font-medium ${
        isConnected 
          ? 'bg-green-100 text-green-800 border border-green-200' 
          : 'bg-red-100 text-red-800 border border-red-200'
      }`}>
        <div className={`w-2 h-2 rounded-full ${
          isConnected ? 'bg-green-500 animate-pulse' : 'bg-red-500'
        }`}></div>
        <span>{isConnected ? 'Connected' : 'Disconnected'}</span>
        {isConnected && (
          <span className="text-xs text-gray-600">
            ({onlineUsers.size} online)
          </span>
        )}
      </div>
    </div>
  );
};

export default ConnectionStatus;
